const clickOutside = {
  bind(el: HTMLElement & any, binding: any, vnode: any) {
    el.clickOutsideEvent = function (event) {
      if (!(el === event.target || el.contains(event.target))) {
        if (!(binding.value instanceof Function)) {
          throw new Error(
            `Bad binding for: ${binding.expression}. Try removing the ()`,
          );
        }
        binding.value(event);
      }
    };
    document.body.addEventListener("click", el.clickOutsideEvent);
  },
  unbind(el) {
    document.body.removeEventListener("click", el.clickOutsideEvent);
    delete el.clickOutsideEvent;
  },
};

export default clickOutside;
